import { useProductImages } from '../hooks/useProductImages';
import CaretLeft from '@vtex/styleguide/lib/icon/CaretLeft';

const SwiperCaretPrev = () => {
	const { blockClass } = useProductImages();

	const renderClass = () => {
		return (
			blockClass &&
			`vtex-store-components-3-x-swiperCaret--${blockClass} vtex-store-components-3-x-swiperCaretPrev--${blockClass}`
		);
	};

	return (
		<span
			className={`swiperCaret swiperCaretPrev swiperCaret--${blockClass} swiperCaretPrev--${blockClass} swiper-caret-prev pr7 pl2 left-0 pv8 absolute top-50 translate--50y z-2 pointer c-action-primary vtex-store-components-3-x-swiperCaret vtex-store-components-3-x-swiperCaretPrev c-disabled vtex-store-components-3-x-carouselCursorDefault ${renderClass()}`}
		>
			<CaretLeft orientation="left" size={24} />
		</span>
	);
};

export default SwiperCaretPrev;
